$ ->
  $('#new_demo_extended #demo_extended_day_starting').datepicker $.datepicker.regional["it"]